import ResultList from './ResultList';

export default ResultList;
